<template>
    <div class="audition-table">
        <div class="head">
            <div class="tit">{{ periodName ? periodName + ' · ' : '' }}战绩积分排行</div>
            <div class="nav">
                <span
                    v-for="(item, index) in headNav.arr"
                    :key="index"
                    :class="{ active: headNav.active === index }"
                    @click="onPeriodNav(index)">{{ item }}</span>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="list"
            :border="true"
            style="width:100%"
            class="audition-rank-table"
            :header-cell-style="{ background: '#347CAF', color: '#fff' }">
            <el-table-column label="排名" width="72" align="center">
                <template slot-scope="{ $index }">
                    <span v-if="showRankMedal($index)" class="rank-img">
                        <img :src="require(`@/assets/common/rank/${$index + 1}.gif`)" alt="">
                    </span>
                    <span v-else class="audition-rank-no">{{ rankNo($index) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="方案名称" min-width="150">
                <template slot-scope="{ row }">
                    <span>{{ row.title }}</span>
                    <span v-if="row.isTop === 1" class="entry-badge top">置顶</span>
                    <span v-if="row.isFeatured === 1" class="entry-badge featured">加精</span>
                </template>
            </el-table-column>
            <el-table-column label="彩种" width="90">
                <template slot-scope="{ row }">{{ preTypeLabel(row.preType) }}</template>
            </el-table-column>
            <el-table-column label="期号" prop="issueNumber" width="96" />
            <el-table-column label="往期累计" width="100" align="center">
                <template slot-scope="{ row }">
                    <span :class="{ 'audition-cell-empty': isEmpty(row.totalScore) }">{{ formatScore(row.totalScore) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="本期命中" width="88" align="center">
                <template slot-scope="{ row }">
                    <span :class="{ 'audition-cell-empty': row.redHitCount == null }">{{ row.redHitCount != null ? row.redHitCount + ' 个' : '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="本期积分" width="100" align="center">
                <template slot-scope="{ row }">
                    <span :class="{ 'audition-cell-empty': isEmpty(row.periodScore) }">{{ formatScore(row.periodScore) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提交时间" width="160">
                <template slot-scope="{ row }">
                    <span :class="{ 'audition-cell-empty': !row.createTime }">{{ row.createTime || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创作者" prop="userName" width="100" />
            <el-table-column label="操作" width="80" fixed="right" align="center">
                <template slot-scope="{ row }">
                    <el-button type="text" size="small" class="title-link" @click.stop="goDetail(row.id)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="total > 0"
            style="padding-top:20px;text-align:right"
            background
            layout="prev, pager, next"
            :current-page="query.pageNum"
            :page-size="query.pageSize"
            :total="total"
            @current-change="changePage" />
        <div v-if="!loading && !list.length" class="audition-empty">暂无方案，欢迎提交万元实战单参与海选</div>
    </div>
</template>

<script>
import { listEntry } from '@/api/audition'

export default {
    name: 'EntryRankList',
    props: {
        periodId: { type: [Number, String], default: null },
        periodName: { type: String, default: '' },
        lotteryOptions: { type: Array, default: () => [] },
        lotteryActive: { type: String, default: '' },
        sort: { type: String, default: 'score' }
    },
    data () {
        return {
            loading: false,
            list: [],
            total: 0,
            headNav: {
                arr: ['最新期', '上一期', '下一期'],
                active: 0
            },
            query: {
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    watch: {
        periodId () {
            this.query.pageNum = 1
            this.getList()
        },
        lotteryActive () {
            this.headNav.active = 0
            this.query.pageNum = 1
            this.getList()
        },
        sort () {
            this.query.pageNum = 1
            this.getList()
        }
    },
    mounted () {
        if (this.periodId) {
            this.getList()
        }
    },
    methods: {
        onPeriodNav (index) {
            this.headNav.active = index
            this.$emit('period-nav', index)
        },
        resetNav () {
            this.headNav.active = 0
        },
        preTypeLabel (val) {
            const item = this.lotteryOptions.find(o => o.dictValue === val)
            return item ? item.dictLabel : val
        },
        isEmpty (val) {
            return val == null || val === ''
        },
        formatScore (val) {
            if (this.isEmpty(val)) return '-'
            return Number(val).toLocaleString()
        },
        rankNo (index) {
            return (this.query.pageNum - 1) * this.query.pageSize + index + 1
        },
        showRankMedal (index) {
            return this.sort === 'score' && this.query.pageNum === 1 && index < 3
        },
        getList () {
            if (!this.periodId) {
                this.list = []
                this.total = 0
                this.loading = false
                return
            }
            this.loading = true
            const params = {
                pageNum: this.query.pageNum,
                pageSize: this.query.pageSize,
                sort: this.sort,
                preType: this.lotteryActive || undefined,
                periodId: this.periodId
            }
            listEntry(params).then(res => {
                if (res.code === 200) {
                    this.list = res.rows || []
                    this.total = res.total || 0
                } else {
                    this.$message.error(res.msg || '加载失败')
                }
                this.loading = false
            }).catch(() => { this.loading = false })
        },
        changePage (page) {
            this.query.pageNum = page
            this.getList()
        },
        refresh () {
            this.getList()
        },
        goDetail (id) {
            this.$router.push('/hxwysz/detail/' + id)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../audition.scss";
</style>
